// @mui material components
import { styled, Theme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { TypographyProps } from "@mui/system";
import linearGradient from "../../../../assets/theme/functions/linearGradient";

interface MDTypographyRootProps extends TypographyProps {
  theme: any,
  [rest: string]: any;
}

export default styled(Typography)(({ theme, ownerState }: MDTypographyRootProps) => {
  const { palette, typography } = theme;
  const { color, textTransform, verticalAlign, fontWeight, opacity, textGradient, darkMode, backgroundColor } =
    ownerState;

  const { gradients, transparent, white } = palette;
  const { fontWeightLight, fontWeightRegular, fontWeightMedium, fontWeightBold } = typography;
  //const { linearGradient } = functions;

  // fontWeight styles
  interface IFontWeights {
    [key: string]: string | boolean | number;
  };

  const fontWeights : IFontWeights = {
    light: fontWeightLight,
    regular: fontWeightRegular,
    medium: fontWeightMedium,
    bold: fontWeightBold,
  };

  // styles for the typography with textGradient={true}
  const gradientStyles = () => ({
    backgroundImage:
      color !== "inherit" && color !== "text" && color !== "white" && gradients[color]
        ? linearGradient(gradients[color].main, gradients[color].state)
        : linearGradient(gradients.dark.main, gradients.dark.state),
    display: "inline-block",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: transparent.main,
    position: "relative",
    zIndex: 1,
  });

  // color value
  let colorValue = color === "inherit" || !palette[color] ? "inherit" : palette[color].main;

  let backgroundColourValue = ownerState.backgroundColor;

  if (darkMode && (color === "inherit" || !palette[color])) {
    colorValue = "inherit";
  } else if (darkMode && color === "dark") colorValue = white.main;

  return {
    opacity,
    textTransform,
    verticalAlign,
    textDecoration: "none",
    color: colorValue,
    backgroundColor: backgroundColourValue,
    fontWeight: fontWeights[fontWeight] && fontWeights[fontWeight],
    ...(textGradient && gradientStyles()),
  };
});
